export const facilitiesFields = `
  items {
    id: _id
    title
    icon
  }
`;
